import { History } from 'history'

export function urlHasSearchParam(param: string): boolean {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.has(param)
}

export function getSearchParam(param: string): string {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(param)
}

/**
 * Extracts the resource path from a project-based pathname by stripping the
 * `/project/:code` prefix.  e.g. "/project/abc/equipment" → "/equipment".
 * Falls back to the full pathname when the prefix is absent.
 */
export function getResourceSegment(pathname: string): string {
  const match = pathname.match(/^\/project\/[^/]+(\/.+)$/)
  return match ? match[1] : pathname
}

/**
 * Removes a search parameter from the URL.
 * Directly modifies the browser's history without reloading the page.
 * If a history object is provided, it will also update the history state (pass `history` from `Common.store.ts` if possible).
 */
export function removeFromSearchParam(param: string, history?: History): void {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.delete(param)
  const newSearch = `?${urlParams.toString()}`
  window.history.replaceState(null, '', newSearch)
  if (history && typeof history.replace === 'function') {
    history.replace(newSearch)
  }
}
